import React, { ReactElement, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import {
  InsetText, Loader, LoaderButton, Text,
} from 'idsk-react-components';
import SprievodnyDokumentListTable from './component/SprievodnyDokumentZmenaPoradiaListTable';
import './sprievodnyDokumentZmenaPoradia.scss';
import LegislativnyMaterialDetail
  from '../../../model/legislativnyMaterial/LegislativnyMaterialDetail';
import useSprievodnyDokumentList from './hook/useSprievodnyDokumentList';
import SprievodnyDokument from '../../../model/legislativnyMaterial/SprievodnyDokument';
import routes from '../../../routing/routes';
import { useSuccessMessageContext } from '../../../context/SuccessMessageContext';
import { useClient } from '../../../context/ClientStatusContext';
import { changeOrder } from '../../../client/admin/external/zmenaPoradiaClient';
import { getInitialStadium } from '../../../function/getLatestStadium';
import StadiumMaterialuHistoriaList
  from '../../../model/legislativnyMaterial/StadiumMaterialuHistoriaList';

interface Props {
  materialDetail: LegislativnyMaterialDetail;
  legMaterialHistoriaList: StadiumMaterialuHistoriaList;
}

const SprievodnyDokumentZmenaPoradia = ({
  materialDetail,
  legMaterialHistoriaList,
}: Props): ReactElement => {
  const { search } = useLocation();
  const stadiumUuidSearchParam = new URLSearchParams(search).get('stadiumUuid');
  const selectedStadium = getInitialStadium(legMaterialHistoriaList, stadiumUuidSearchParam);
  const { displaySuccess } = useSuccessMessageContext();
  const navigate = useNavigate();
  const {
    type,
    year,
    index,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number }>();
  const [updatedList, setUpdatedList] = useState<SprievodnyDokument[]>();
  const {
    wrapClient: changeOrderClient,
    status: changeOrderStatus,
  } = useClient(changeOrder);

  const {
    sprievodnyDokumentList,
    sprievodnyDokumentStatus,
  } = useSprievodnyDokumentList(materialDetail.uuid, selectedStadium.uuid);

  const saveOrder = async (): Promise<void> => {
    await changeOrderClient(materialDetail.uuid, selectedStadium.uuid, updatedList || sprievodnyDokumentList);
    navigate(routes.procesy.detail.sprievodneDokumenty.editAsAdmin.withParams(
      type,
      year,
      index,
      selectedStadium.uuid,
    ));
    displaySuccess('Nové poradie dokumentov zobrazených v režime '
      + 'prehliadania pre zvolené štádium materiálu bolo úspešne uložené.');
  };

  return (
    <div className="sprievodny-dokument-zmena-poradia-list">
      <Text
        className="sprievodny-dokument-zmena-poradia-list__stadium-popis "
      >Zobrazujú sa sprievodné dokumenty vo fáze:
      </Text>
      {selectedStadium.stadium && (
        <Text
          className="sprievodny-dokument-zmena-poradia-list__stadium"
          bold
        >{selectedStadium.stadium.nazov}
        </Text>
      )}
      <InsetText type="warn">
        <Text type="span" bold>Pre aplikovanie zmien poradia dokumentov je potrebné
          použiť tlačidlo “Uložiť nové poradie dokumentov” v spodnej časti obrazovky.
        </Text>
      </InsetText>
      <div className="sprievodny-dokument-list">
        <Loader loading={sprievodnyDokumentStatus.loading}>
          {sprievodnyDokumentList && (
          <SprievodnyDokumentListTable
            sprievodnyDokumentList={updatedList || sprievodnyDokumentList}
            setUpdatedList={setUpdatedList}
          />
          )}
        </Loader>
      </div>
      <div className="sprievodny-dokument-zmena-poradia__buttons-container">
        <LoaderButton
          size="large"
          className="sprievodny-dokument-zmena-poradia__submit-button"
          type="submit"
          onClick={saveOrder}
          loading={changeOrderStatus.loading}
          disableOutsideClickWhileLoading
        >Uložiť nové poradie dokumentov
        </LoaderButton>
      </div>
    </div>
  );
};

export default SprievodnyDokumentZmenaPoradia;
